import type { ReactNode } from 'react';

export const symbol_linear_scale: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M680-280q-74 0-129-47t-69-123H276q-10 29-36.5 49.5T179-380q-41 0-70.5-29.5T79-480q0-41 29.5-70.5T179-580q34 0 60.5 20.5T276-510h206q14-76 69-123t129-47q83 0 141.5 58.5T880-480q0 83-58.5 141.5T680-280Zm99.5-100.5Q820-421 820-480t-40.5-99.5Q739-620 680-620t-99.5 40.5Q540-539 540-480t40.5 99.5Q621-340 680-340t99.5-40.5Z"
		/>
	</svg>
);
